import { ENUMS } from "../../utils/Enums";
import { FILTER } from "../../utils/Struct";
import Input from "../../ui/Input";
import Button from "../../ui/Button";
import Space from "../../ui/Space";
import DateField from "../../ui/DateField";
import dayjs from "dayjs";
import SelectBox from "../../ui/SelectBox";
import FilterBase from "./FilterBase";
import { bm_date, addCellDashes } from "../../utils/Utils";

export default function GenericConditional(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, allow_in = false, date = false, edit = false, inputParams = { number: true, maxLength: 3, width: 35 }, phone = false } = props;

    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let _data = ENUMS.CUSTOMER_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }

    const formatPhone = (val) => {
        const [num, ...rest] = String(val || "").split(" ");
        return addCellDashes(num) + (rest.length ? " " + rest.join(" ") : "");
    };


    const fields = [
        { key: "comparison", value: (edit) ? filter.comparison : "=", help: "" },
        { key: "value_1", value: (edit) ? filter.value_1 : (inputParams.number) ? "" : "", help: "Enter the data to complete this filter." },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value;
        let value_1 = tabs.find(f => f.key === "value_1").value;

        if (date) {
            value_1 = bm_date(value_1, "YYYY-MM-DD");
        }

        if (phone) {
            value_1 = formatPhone(value_1);
        }

        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
            value_1: value_1.toString()
        }
        onSave(_f, filter);
    }

    return (
        <FilterBase controller={controller} start_index={0} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, refs, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <SelectBox
                            width={110}
                            {...editProps("comparison")}
                            options={[
                                { value: "=", label: "Equal to" },
                                { value: "<", label: "Less than"},
                                { value: ">", label: "Greater than"},
                            ]}
                        />
                        {(!date && <Input {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />)}
                        <Button onClick={() => save(tabs)} {...editProps("save")} >Save</Button>
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}